import { render, staticRenderFns } from "./problem-add-or-update.vue?vue&type=template&id=3eed474f&scoped=true"
import script from "./problem-add-or-update.vue?vue&type=script&lang=js"
export * from "./problem-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./problem-add-or-update.vue?vue&type=style&index=0&id=3eed474f&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eed474f",
  null
  
)

export default component.exports